import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: null,
	loading: false,

	pagination: {
		page: 1,
		perPage: 10,
		totalItems: 0,
		totalPage: 0,
	},

	selectedSite: "",
	loadingSite: false,
	selectedVoucher: "",
	loadingVouchers: false,
	vouchersData: null,

	vouchersPagination: {
		page: 1,
		perPage: 5,
		totalItems: 0,
		totalPage: 0,
	},
};

const projectOverviewSlice = createSlice({
	name: "projectoverview",
	initialState,
	reducers: {
		setProjectOverviewData: (state, action) => {
			state.data = action.payload.data;
			state.pagination.totalItems = action.payload.totalItems;
			state.pagination.page = action.payload.page;
			state.pagination.perPage = action.payload.perPage;
			state.pagination.totalPage = action.payload.totalPage;
		},

		setLoadingProjectOverview: (state, action) => {
			state.loading = action.payload;
		},
		setSlectedSite: (state, action) => {
			state.selectedSite = action.payload;
		},
		setLoadingSite: (state, action) => {
			state.loadingSite = action.payload;
		},
		setSelectedVoucher: (state, action) => {
			state.selectedVoucher = action.payload;
		},

		setLoadingVouchers: (state, action) => {
			state.loadingVouchers = action.payload;
		},
		setVouchersData: (state, action) => {
			state.vouchersData = action.payload.data;

			// Ensure vouchersPagination exists
			// if (!state.vouchersPagination) {
			//   state.vouchersPagination = {
			//     page: 1,
			//     perPage: 5,
			//     totalItems: 0,
			//     totalPage: 0,
			//   };
			// }

			state.vouchersPagination.totalItems = action.payload.totalItems ?? 0;
			state.vouchersPagination.page = action.payload.page ?? 1;
			state.vouchersPagination.perPage = action.payload.perPage ?? 5;
			state.vouchersPagination.totalPage = Math.ceil(
				(action.payload.totalItems ?? 0) / (action.payload.perPage ?? 5),
			);
		},
	},
});

export const {
	setProjectOverviewData,
	setLoadingProjectOverview,
	setSlectedSite,
	setLoadingSite,
	setSelectedVoucher,
	setLoadingVouchers,
	setVouchersData,
} = projectOverviewSlice.actions;
export default projectOverviewSlice.reducer;
